"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCustomerOrders = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const currentWebsiteContext_1 = require("../../../../contexts/currentWebsiteContext");
const customerAccountContext_1 = require("../../../../contexts/customerAccountContext");
const DefaultOrderRow_1 = require("./DefaultOrderRow");
const DefaultOrdersHeader_1 = require("./DefaultOrdersHeader");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const constants_1 = require("../../../../constants");
const DefaultCustomerOrders = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const [customerOrders, setCustomerOrders] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const { currentWebsite } = (0, react_1.useContext)(currentWebsiteContext_1.CurrentWebsiteContext);
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { orders } = customerAccountContext.actions;
    (0, react_1.useEffect)(() => {
        if (customerAccountContext.customerId) {
            orders
                .getOrders({
                customerId: customerAccountContext.customerId,
                storeCode: `${currentWebsite}_${currentLocale.toLowerCase()}`,
            })
                .then((data) => {
                if (data)
                    setCustomerOrders(data.orders);
            })
                .catch(() => { })
                .finally(() => setIsLoading(false));
        }
    }, [customerAccountContext.customerId]);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-default-orders-container" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-default-orders-title" }, t("customerAccount.orders.sectionTitle")),
        isLoading ? (react_1.default.createElement("div", { className: "boutik-customer-account-default-orders-spinner-container" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "boutik-customer-account-default-orders-spinner", icon: pro_solid_svg_icons_1.faSpinnerThird, spin: true }))) : (react_1.default.createElement("div", { className: "boutik-customer-account-default-orders-list-container" }, customerOrders.length === 0 ? (react_1.default.createElement("span", { className: "boutik-customer-account-default-orders-no-order" }, t("customerAccount.orders.noOrder"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DefaultOrdersHeader_1.DefaultOrdersHeader, null),
            customerOrders.map((order, key) => (react_1.default.createElement(DefaultOrderRow_1.DefaultOrderRow, { key: key, order: order })))))))));
};
exports.DefaultCustomerOrders = DefaultCustomerOrders;
//# sourceMappingURL=DefaultCustomerOrders.js.map